<template>
  <div>
    <v-row>
      <v-col>
        <v-text-field
          color="primary"
          hide-details
          :style="`font-size: 14px;`"
          label="Label"
          type="text"
          :class="[getDirtyClass(item, 'label'), isLocked ? 'disable-events' : '']"
          @update:model-value="
            setNestedParameter({ value: $event, item: item, parameter: 'label' }),
              addDirty(item, 'label')
          "
          :model-value="item.label"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-select
          color="primary"
          hide-details
          clear-icon="mdi-close"
          clearable
          :class="[getDirtyClass(item, 'topo_profile_point'), isLocked ? 'disable-events' : '']"
          label="Topo profile point"
          :items="topoProfilePointOptions"
          item-value="id"
          item-title="id"
          @update:model-value="
            setNestedParameter({ value: $event, item: item, parameter: 'topo_profile_point' }),
              addDirty(item, 'topo_profile_point')
          "
          :model-value="item.topo_profile_point"
        >
          <template v-slot:prepend-item>
            <v-row no-gutters class="pl-4">
              <v-col cols="6" class="v-card__subtitle text--secondary">Name</v-col>
              <v-col class="pl-0 v-card__subtitle text--secondary">X</v-col>
              <v-col class="pl-0 v-card__subtitle text--secondary"> Y</v-col>
            </v-row>
            <v-divider class="mt-2"></v-divider>
          </template>
          <template v-slot:item="{ item, props }">
            <v-list-item v-bind="{ ...props, title: '' }">
              <v-row no-gutters>
                <v-col cols="6">{{ getName(item.raw.properties.name) }}</v-col>
                <v-col>{{ item.raw.geometry.coordinates[0] }}</v-col>
                <v-col> {{ item.raw.geometry.coordinates[1] }}</v-col>
              </v-row>
            </v-list-item>
          </template>
          <template v-slot:selection="{ item, props }">
            <span class="elip">
              {{ getName(item.raw.properties.name) }}
            </span>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          color="primary"
          :rules="[(v) => v <= item.end || `Start of load must be lower than end of load`]"
          hide-details
          :class="[getDirtyClass(item, 'start'), isLocked ? 'disable-events' : '']"
          :style="`font-size: 14px;`"
          :label="
            item.topo_profile_point ? `Start of load from topo profile point` : `Start of load`
          "
          type="number"
          @update:model-value="
            setNestedParameter({ value: $event, item: item, parameter: 'start' }),
              addDirty(item, 'start')
          "
          :model-value="item.start"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          color="primary"
          hide-details
          :rules="[(v) => v >= item.start || `End of load must be higher than start of load`]"
          :style="`font-size: 14px;`"
          :class="[getDirtyClass(item, 'end'), isLocked ? 'disable-events' : '']"
          :label="item.topo_profile_point ? `End of load from topo profile point` : `End of load`"
          type="number"
          @update:model-value="
            setNestedParameter({ value: $event, item: item, parameter: 'end' }),
              addDirty(item, 'end')
          "
          :model-value="item.end"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          color="primary"
          hide-details
          :style="`font-size: 14px;`"
          :class="[getDirtyClass(item, 'magnitude'), isLocked ? 'disable-events' : '']"
          label="Magnitude"
          type="number"
          @update:model-value="
            setNestedParameter({ value: $event, item: item, parameter: 'magnitude' }),
              addDirty(item, 'magnitude')
          "
          :model-value="item.magnitude"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          color="primary"
          hide-details
          :style="`font-size: 14px;`"
          :class="[getDirtyClass(item, 'spread'), isLocked ? 'disable-events' : '']"
          step="15"
          label="Spread"
          type="number"
          @update:model-value="
            setNestedParameter({ value: $event, item: item, parameter: 'spread' }),
              addDirty(item, 'spread')
          "
          :model-value="item.spread"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          color="primary"
          hide-details
          :style="`font-size: 14px;`"
          :class="[getDirtyClass(item, 'drained_material'), isLocked ? 'disable-events' : '']"
          label="Drained consolidation [%]"
          type="number"
          @update:model-value="
            setNestedParameter({ value: $event, item: item, parameter: 'drained_consolidation' }),
              addDirty(item, 'drained_consolidation')
          "
          :model-value="item.drained_consolidation"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          color="primary"
          hide-details
          class="mb-3"
          :style="`font-size: 14px;`"
          :class="[
            getDirtyClass(item, 'undrained_consolidation'),
            isLocked ? 'disable-events' : ''
          ]"
          step="15"
          label="Undrained consolidation [%]"
          type="number"
          @update:model-value="
            setNestedParameter({ value: $event, item: item, parameter: 'undrained_consolidation' }),
              addDirty(item, 'undrained_consolidation')
          "
          :model-value="item.undrained_consolidation"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import DirtyFieldsStateMixIn from '@/mixins/DirtyFieldsStateMixIn.vue'

export default {
  name: 'UniformLoad',
  mixins: [DirtyFieldsStateMixIn],
  props: {
    item: { required: true }
  },
  data: () => ({
    storeName: 'uniformLoads'
  }),
  computed: {
    ...mapGetters('topoProfilePoint', {
      topoProfilePointOptions: 'topoProfilePointOptions',
      getItem: 'getItem',
      getName: 'getName',
      options: 'options'
    }),
    ...mapState('uniformLoads', {
      currentItem: (state) => state.currentItem,
      loading: (state) => state.loading
    }),
    ...mapGetters('stabSchematisation', {
      isLocked: 'isLockedCurrent'
    }),
    getTopoProfilePointItem() {
      return this.getItem(this.item.topo_profile_point)
    }
    // TODO get beautiful names
  },
  methods: {
    ...mapActions('uniformLoads', {
      setNestedParameter: 'setNestedParameter'
    }),
    close() {
      this.$refs.form.resetValidation()
    }
  }
}
</script>
